/* websocket功能封装 */

import Vue from 'vue'
import {Toast} from 'vant'
import {getAccessToken} from './auth'

let vue = new Vue()
vue.$message = Toast

var webSocket = null
var isConnect = false // 连接状态
var globalCallback = function (e) {
  console.log(e)
}// 客户端发送数据的回调函数
var reConnectNum = 0// 重连次数
let onlineIp = window.location.origin.split('//')[1]
// 心跳设置
var heartCheck = {
  heart: 'heart', // 心跳包
  timeout: 60 * 1000, // 每段时间发送一次心跳包
  heartbeat: null, // 延时发送消息对象(启动心跳新建这个对象，收到消息后重置对象)
  start: function () {
    this.heartbeat = setInterval(() => {
      if (isConnect) {
        webSocketSend(this.heart)
      } else {
        this.clear()
      }
    }, this.timeout)
  },
  reset: function () {
    clearInterval(this.heartbeat)
    this.start()
  },
  clear: function () {
    clearInterval(this.heartbeat)
  }
}

// 初始化websocket
function initWebSocket (callback) {
  let websocketUrl = setWebsocketUrl() // 请求地址
  // 此callback为在客户端发送数据的回调函数
  if (callback) {
    if (typeof callback === 'function') {
      globalCallback = callback
    } else {
      throw new Error('callback is not a function')
    }
  }
  if ('WebSocket' in window) {
    webSocket = new WebSocket(websocketUrl)// 创建socket对象
  } else {
    vue.$message('该浏览器不支持websocket!')
    return
  }
  // 打开
  webSocket.onopen = function () {
    webSocketOpen()
  }
  // 接收到服务端信息
  webSocket.onmessage = function (e) {
    webSocketOnMessage(e)
  }
  // 关闭
  webSocket.onclose = function (e) {
    webSocketOnClose(e)
  }
  // 连接发生错误的回调方法
  webSocket.onerror = function (e) {
    webSocketonError(e)
  }
}

// 连接socket建立时触发
function webSocketOpen () {
  console.log('WebSocket连接成功')
  // 首次握手
  // webSocketSend(heartCheck.heart)
  isConnect = true
  // heartCheck.start()
  reConnectNum = 0
}

// 客户端接收服务端数据时触发,e为接受的数据对象
function webSocketOnMessage (e) {
  globalCallback(e.data)// 将data传给在外定义的接收数据的函数。
}

// socket关闭时触发
function webSocketOnClose (e) {
  heartCheck.clear()
  isConnect = false
  console.log(e)
  console.log('webSocket已经关闭 (code：' + e.code + ')')
  // 被动断开，重新连接
  if (e.code === 1006) {
    if (reConnectNum < 3) {
      setTimeout(function () {
        initWebSocket()
        ++reConnectNum
      }, 10000)
    } else {
      vue.$message.loading({
        duration: 10000,
        message: '客服连接断开，请检查本地网络是否正常。'
      })
    }
  }
}

// 连接发生错误的回调方法
function webSocketonError (e) {
  heartCheck.clear()
  isConnect = false
  console.log('WebSocket连接发生错误:', e)
}

// 发送数据
function webSocketSend (data) {
  webSocket.send(JSON.stringify(data))
}

// 在其他需要socket地方主动关闭socket
function closeWebSocket () {
  isConnect = false
  reConnectNum = 0
  webSocket.close()
  heartCheck.clear()
}

// 在其他需要socket地方接受数据
function getSock (callback) {
  globalCallback = callback
}

// 在其他需要socket地方调用的函数，用来发送数据及接受数据
function sendSock (agentData) {
  if (webSocket === null) {
    return 'closed'
  } else {
    // 下面的判断主要是考虑到socket连接可能中断或者其他的因素，可以重新发送此条消息。
    switch (webSocket.readyState) {
      // CONNECTING：值为0，表示正在连接。
      case webSocket.CONNECTING:
        setTimeout(function () {
          sendSock(agentData)
        }, 1000)
        break
      // OPEN：值为1，表示连接成功，可以通信了。
      case webSocket.OPEN:
        webSocketSend(agentData)
        break
      // CLOSING：值为2，表示连接正在关闭。
      case webSocket.CLOSING:
        setTimeout(function () {
          sendSock(agentData)
        }, 1000)
        break
      // CLOSED：值为3，表示连接已经关闭，或者打开连接失败。
      case webSocket.CLOSED:
        console.log('连接已经关闭')
        return 'closed'
    }
  }
}

// 获取当前是否连接
function isConnectFn () {
  return isConnect
}

// 设置websocket连接地址
function setWebsocketUrl () {
  let wsProtocol = 'ws://' // websocket协议
  let protocol = window.location.protocol // 当前url协议
  if (protocol.indexOf('https') !== -1) {
    wsProtocol = 'wss://'
  }
  let websocketUrl = wsProtocol + onlineIp + '/cs/client/websocket/' + getAccessToken()// websocket请求地址
  return websocketUrl
}

export default {
  initWebSocket,
  closeWebSocket,
  sendSock,
  getSock,
  isConnectFn
}



// WEBPACK FOOTER //
// ./src/util/websocket.js